import { StrictMode, createContext, useContext } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "../../src/js/api/queryClient";
import { MyStyleWidget } from "./components/my-style/my-style-widget";

const MyStyleContext = createContext();
export const useMyStyleContext = () => useContext(MyStyleContext);
function MyStyleProvider({ data, children }) {
  return (
    <MyStyleContext.Provider value={data}>
      {children}
    </MyStyleContext.Provider>
  );
}

function MyStyleRenderer() {
  const rootElement = document.getElementById("my-profile__my-style-widget");
  if (!rootElement) return;

  let initialProps = {};
  try {
    initialProps = JSON.parse(rootElement.getAttribute("data-initial-props"));
  } catch (error) {
    console.error(
      error,
      "Could not parse initial props JSON for MyStyle"
    );
  }

  createRoot(rootElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <MyStyleProvider data={initialProps}>
          <MyStyleWidget />
        </MyStyleProvider>
      </QueryClientProvider>
    </StrictMode>
  );
}

export const initMyStyle = () => {
  if (document.readyState !== "loading") {
    MyStyleRenderer();
  } else {
    document.addEventListener("DOMContentLoaded", MyStyleRenderer);
  }
};
